<template>
    <div>
        <div>Test content</div>
        <div class="h3" v-html="resetContentText"></div>
        <div class="d-flex justify-content-center align-items-center w-100">
            <button
            @click="handleAPICall"
            class="btn btn-round btn-primary mx-auto mb-2 mt-2"
            v-html="resetContentButtonText"></button>
        </div>
        <div class="alert alert-success mt-3" role="alert" v-if="successMsg" v-html="resetContentSuccessMessage"></div>
        <div class="alert alert-danger mt-3" role="alert" v-if="errorMesg" v-html="resetContentErrorMessage"></div>
    </div>
</template>
<script>
import axios from "axios";
export default {
    props: {
        resetContentText: {
            type: String,
            default: "",
        },
        resetContentButtonText: {
            type: String,
            default: "",
        },
        resetContentSuccessMessage: {
            type: String,
            default: "",
        },
        resetContentErrorMessage: {
            type: String,
            default: "",
        },
        resetContentEndpoint: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            successMsg: false,
            errorMesg: false,
        };
    },
    methods: {
        handleAPICall() {
            axios
                .post(`${this.resetContentEndpoint}`)
                .then((res) => {
                    console.log(res);
                    this.errorMesg = false;
                    this.successMsg = true;
                })
                .catch((err) => {
                    console.log(err);
                    this.errorMesg = true;
                    this.successMsg = false;
                });
        },
    },
};
</script>


// WEBPACK FOOTER //
// demo/pages/components/aha-reset-personalization.vue